import React, { useEffect, useState } from "react";
import { JsonEditor as Editor } from "jsoneditor-react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  AlertTitle,
  Avatar,
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  ImageListItem,
  ImageListItemBar,
  MenuItem,
  Modal,
  Stack,
  Switch,
  Tab,
  TextField,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import Div from "@jumbo/shared/Div/Div";
import { useFormikContext } from "formik";

const FIELD_NAME = "TRANSLATIONS_FIELD";

const SmartkioskTranslations = ({
  handleChange,
  expanded,
  hideSectionTitle = false,
}) => {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext();
  const [translationsData, setTranslationsData] = useState({});

  const handleTranslationsChange = (value) => {
    setTranslationsData(value);
    setFieldValue(`settings.translations`, value);
  };

  const content = (
    <Grid container spacing={2}>
          <Grid item xs={12} md={12} lg={12}>
            <Div sx={{ mt: 1, mb: 1 }}>
              <Editor
                value={values?.settings?.translations || {}}
                onChange={(e) => handleTranslationsChange(e)}
                mode="code"
                mainMenuBar={false}
                navigationBar={false}
              />
            </Div>
          </Grid>
        </Grid>
  );

  if (hideSectionTitle) {
    return content;
  }

  return (
    <Accordion
      expanded={expanded === FIELD_NAME}
      onChange={handleChange(FIELD_NAME)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={{ width: "33%", flexShrink: 0 }}>
          {t("pages.dsokDetails.translations")}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{content}</AccordionDetails>
    </Accordion>
  );
};

export default SmartkioskTranslations;
